import React, { Component } from "react"
import Helper from "../utils/helper";
import './ManufacturerItem.css';

export default class ManufacturerItem extends Component {
    render() {
        const { item } = this.props;
        return (
            <a className="m-item"
                href={item.innerWebsiteName ? Helper.getMyCompanySiteLink(item.innerWebsiteName) : item.websiteLink}
                rel={item.innerWebsiteName ? '' : 'nofollow'}
                target="_blank"
                key={item.id}
            >
                <div className="m-image-item" >
                    <img src={item.logo ? item.logo : "/img/welder.png"} />
                </div>
                <div className="align-center">{item.name}</div>
                {item.address &&
                    <div className="m-addess-item multiline">{item.address}</div>
                }
            </a>
        );
    }
}